module.exports = __webpack_public_path__ + "static/img/guide-01.81c435c7.png";